import { useEffect } from 'react';
import { matchPath, useHistory } from 'react-router-dom';
import { SIGN_IN_PATH, FORGOT_PASSWORD_PATH, RESET_PASSWORD_PATH } from '../paths.constants';
import { useLocalStorage } from '../../providers/local-storage-provider/local-storage.context';
import { useActions } from '../../providers/actions-provider/actions.context';
import {
  ACCESS_TOKEN_KEY,
  ACCESS_TOKEN_EXPIRY_KEY,
  USER_ID,
  REFRESH_TOKEN_KEY,
} from '../../../store/modules/user/user.constants';

export const useRootHook = (): boolean => {
  const localStorageService = useLocalStorage();
  const {
    userActions, tenantActions, facilityActions, reportActions,
  } = useActions();
  const { push, location: { pathname } } = useHistory();
  // const refreshTimer = useRef<unknown>();
  const accessToken: string | null = localStorageService.get(ACCESS_TOKEN_KEY);
  const refreshToken: string | null = localStorageService.get(REFRESH_TOKEN_KEY);
  const expiryToken: number | null = localStorageService.get(ACCESS_TOKEN_EXPIRY_KEY);
  const userID: number | null = localStorageService.get(USER_ID);
  useEffect(() => {
    if (accessToken
      && expiryToken
      && refreshToken
      && (expiryToken > Date.now())
      && userID != null) {
      // userActions.refreshToken();
      userActions.getCurrentUser(userID);
      userActions.getRolesList();
      tenantActions.getTenantsList();
      facilityActions.getGroupTypes();
      facilityActions.getGroups();
      reportActions.getReports();
    }
  }, []);

  // useEffect(() => {
  //   if (expiryToken) {
  //     clearTimeout(refreshTimer.current as number);
  //     refreshTimer.current = setTimeout(() => {
  //       userActions.refreshToken();
  //     }, 250000);
  //   }
  // }, [refreshToken]);

  const guestPathChecker = matchPath(pathname, {
    path: `/:path(${SIGN_IN_PATH}|${FORGOT_PASSWORD_PATH}|${RESET_PASSWORD_PATH})`,
  });

  if (guestPathChecker) {
    return false;
  }

  if (accessToken
    && expiryToken
    && refreshToken
    && (expiryToken > Date.now())
    && userID != null) {
    return true;
  }

  localStorageService.remove(ACCESS_TOKEN_KEY);
  localStorageService.remove(ACCESS_TOKEN_EXPIRY_KEY);
  localStorageService.remove(USER_ID);

  push(pathname);
  return false;
};

export default useRootHook;
